export function setupAltCartCount() {
    const orderlines = getCookie("orderLinesInCart");
    const qtyElements = document.querySelectorAll(".cart-qty");

    if(qtyElements && orderlines) {
        Array.from(qtyElements).forEach(element => {
            element.innerHTML = orderlines;
            element.setAttribute('data-qty', orderlines);
        })
    }

    Array.from(qtyElements).forEach(element => {
        element.classList.add('show');
    })
}

function getCookie(cookieName) {
    const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));

    if (match) {
        return match[2];
    }

    return false;
}